import type { ParsedUrlQuery } from 'querystring';
import type { InstantSearchServerState } from 'react-instantsearch';
import { ALGOLIA_ATTRIBUTES } from '@shared/utils/src/algolia/algoliaAttributes';
import { getAlgoliaProductIndex } from '../../services';
import { Locale } from '../internationalization';
import { createFacetAttributeNames } from './createFacetAttributeNames';
import { createInitialRefinementList } from './createInitialRefinementList';

export const createAlgoliaServerState = ({
  locale,
  products,
  query,
}: {
  locale?: string;
  products: { [key: string]: unknown };
  query: ParsedUrlQuery;
}) => {
  const algoliaIndex = getAlgoliaProductIndex(locale || Locale.DEFAULT_LOCALE);
  const facets = createFacetAttributeNames(locale);
  const numericRefinements = {
    [ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT]: {},
  };
  const price: {
    [key: string]: number[];
  } = {};

  if (query.minPrice) {
    price['>='] = [Number(query.minPrice)];
  }

  if (query.maxPrice) {
    price['<='] = [Number(query.maxPrice)];
  }
  numericRefinements[ALGOLIA_ATTRIBUTES.PRICE_CENT_AMOUNT] = price;
  const slugValue = (query.slug as string[]) || [];

  return {
    initialResults: {
      [algoliaIndex]: {
        state: {
          page: query.page,
          query: query.query,
          facets: createFacetAttributeNames(locale),
          facetsRefinements: createInitialRefinementList(query, locale),
          numericRefinements,
          index: algoliaIndex,
          disjunctiveFacets: facets,
          configure: {
            hitsPerPage: Number(query.pageSize),
            filters: [
              `${ALGOLIA_ATTRIBUTES.CATEGORIES_KEY}: ${slugValue[slugValue.length - 1]?.split('-c')[0]?.toString()}`,
            ],
          },
        },
        results: [{ ...products }],
      },
    },
  } as unknown as InstantSearchServerState;
};
